import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { useSelector } from 'react-redux';
import { WorkflowHeader } from './WorkflowHeader';
import { PerformanceMetrics } from './PerformanceMetrics';
import { TasksTab } from './TasksTab';
import { WorkflowsTab } from './WorkflowsTab';
import { TemplatesTab } from './TemplatesTab';
import { DifferenceTab } from './DifferenceTab';
import { CreateWorkflowModal } from './CreateWorkflowModal';
import workflowApi from '../../api/workflowApi';
import AddTasks from '../tasks/AddTasks';
import accountApi from '../../api/accountApi';
import { WorkflowTasksPage } from './WorkflowTasks';
import { toast } from 'react-toastify';

export const WorkflowManagement = () => {
    const [activeTab, setActiveTab] = useState('workflowTasks');
    const [showCreateWorkflow, setShowCreateWorkflow] = useState(false);
    const [showCreateTask, setShowCreateTask] = useState(false);
    const [selectedClient, setSelectedClient] = useState('');
    const token = useSelector((state) => state.auth.access_token);
    const [workflows, setWorkflows] = useState([]);
    const [workflowTemplatesTasks, setWorkflowTemplatesTasks] = useState([]);
    const [workflowTemplates, setWorkflowTemplates] = useState([]);
    const [clients, setClients] = useState([]);

    const userData = useSelector((state) => state.auth.userdetails.id);
    const [loading, setLoading] = useState(true);

    const loadTemplates = async () => {
        try {
            const data = await workflowApi.getAllWorkflowTemplates(token);

            const client = await accountApi.getAllAccounts(token);
            setWorkflowTemplatesTasks(data.data || []);
            const useTemplates = data.data.map((workflow) => ({
                id: workflow.id,
                name: workflow.name,
                tasksLength: workflow.tasks ? workflow.tasks.length : 0,
                tasks: workflow.tasks,
                description: workflow.description,
            }));
            const companyData = client.data.content.map((company) => ({
                id: company.id,
                name: company.accountName,
                accountOwner: company.accountOwner,
            }));
            setWorkflowTemplates(useTemplates);
            setClients(companyData);
        } catch (error) {
            console.error('Failed to load workflow templates:', error);
        }
    };

    useEffect(() => {
        loadTemplates();
    }, [token]);
    const [tasks] = useState([]);


    const fetchWorkflows = async () => {
        try {
            setLoading(true);
            const response = await workflowApi.allWorkflow(undefined, token);
            setWorkflows(response?.data || []);
        } catch (error) {
            console.error("Error fetching workflowTemplatesTasks:", error);
            // toast.error("Failed to load workflowTemplatesTasks");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchWorkflows()
    }, [token])



    const allTasks = workflowTemplatesTasks.flatMap(wf =>
        (wf.tasks || []).map(task => ({
            ...task,
            workflowName: wf.name || "Untitled Workflow",
        }))
    );

    const filteredTasks = selectedClient
        ? tasks.filter(task => task.clientId === selectedClient)
        : tasks;

    const filteredWorkflows = selectedClient
        ? workflowTemplatesTasks.filter(workflow => workflow.clientId === selectedClient)
        : workflowTemplatesTasks;
        

    return (
        <div className="space-y-2">
            {/* Performance Metrics */}
            {/* <PerformanceMetrics
                filteredTasks={filteredTasks}
                filteredWorkflows={filteredWorkflows}
            /> */}
            
            <WorkflowHeader
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                selectedClient={selectedClient}
                setSelectedClient={setSelectedClient}
                clients={clients}
                filteredTasks={filteredTasks}
                filteredWorkflows={filteredWorkflows}
                workflowTemplates={workflowTemplates}
                setShowCreateWorkflow={setShowCreateWorkflow}
                setShowCreateTask={setShowCreateTask}
                allTasks={allTasks}
                workflows={workflows}
                loading={loading}
            />


            {/* Content based on active tab */}
            {activeTab === 'tasks' && (
                <TasksTab
                    workflowTemplatesTasks={workflows}
                    onRefreshAccounts={fetchWorkflows}
                />
            )}

            {activeTab === 'workflowTemplatesTasks' && (
                <WorkflowsTab
                    filteredWorkflows={filteredWorkflows}
                />
            )}

            {activeTab === 'templates' && (
                <TemplatesTab
                    workflowTemplates={workflowTemplates}
                />
            )}

            {activeTab === 'difference' && (
                <DifferenceTab />
            )}
            {activeTab === 'workflowTasks' && (
                <WorkflowTasksPage clients={clients} selectedClient={selectedClient} onRefreshAccounts={fetchWorkflows} workflowTemplates={workflowTemplates}/>
            )}

            {/* Create Workflow Modal */}
            {showCreateWorkflow && (
                <CreateWorkflowModal
                    clients={clients}
                    workflowTemplates={workflowTemplates}
                    setShowCreateWorkflow={setShowCreateWorkflow}
                />
            )}

            {/* Create Task Modal */}
            {showCreateTask && (
                <div className="fixed inset-0 bg-black -top-6 bg-opacity-50 z-50 flex items-center justify-center p-4">
                        <AddTasks setShowCreateTask={setShowCreateTask}/>
                </div>
            )}
        </div>
    );
};